import pino from "pino";

// Universal Pino logger that works on both server and client
export const logger = pino({
  level: "info",
});
